import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/sub-admin";

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/add-permission`, values);
};

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/permission-list`,values);
};
